import { useQuery } from 'react-query';

import { useSelectedWatchlist } from '../useSelectedWatchlist';

import { queryFn } from './queryFn';
import { getDefaultResponse } from './mapWatchlistResponseToCache';

export const QUERY_KEY = 'WATCHLIST';

const isError = (e: unknown): e is Error =>
  typeof e !== 'undefined' &&
  'name' in (e as Error) &&
  'message' in (e as Error);

export default function useWatchlist() {
  const [watchlistId, selectWatchlist] = useSelectedWatchlist();

  const {
    data = getDefaultResponse(),
    status,
    isFetched,
    isFetching,
  } = useQuery([QUERY_KEY, watchlistId], queryFn, {
    enabled: typeof watchlistId !== 'undefined',
    staleTime: 3600000,
    retry: 1,
    onError: (e: unknown) => {
      if (
        isError(e) &&
        /Watchlist with id: .* could not be found/.test(e.message)
      ) {
        selectWatchlist(null);
      }
    },
  });

  return {
    id: data.id,
    name: data.name,
    keys: data.keys,
    itemsLimit: data.itemsLimit,
    data: data.watchlist,
    isFetching,
    status,
    isFetched,
  };
}
